import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const SERVER = process.env.REACT_APP_SERVER;
const solutionFileUrl = (fileName) => `${SERVER}/api/upload/homeFiles/${fileName}`;

const service_bg = solutionFileUrl('service_bg.svg');
const solution_icon_1 = solutionFileUrl('solution_icon_1.svg');
const solution_icon_2 = solutionFileUrl('solution_icon_2.svg');
const solution_icon_3 = solutionFileUrl('solution_icon_3.svg');
const solution_icon_4 = solutionFileUrl('solution_icon_4.svg');
const solution_icon_5 = solutionFileUrl('solution_icon_5.svg');
const solution_icon_6 = solutionFileUrl('solution_icon_6.svg');
const solution_icon_7 = solutionFileUrl('solution_icon_7.svg');
const solution_icon_8 = solutionFileUrl('solution_icon_8.svg');
const solution_icon_9 = solutionFileUrl('solution_icon_9.svg');
const solution_icon_10 = solutionFileUrl('solution_icon_10.svg');
const service_icon_1 = solutionFileUrl('service_icon_1.png');
const service_icon_2 = solutionFileUrl('service_icon_2.png');
const img_service_1 = solutionFileUrl('img_service_1.svg');
const img_service_2 = solutionFileUrl('img_service_2.svg');

// 솔루션 4단계 데이터
const solutionsData = [
    {
        id: '01',
        title: '심리평가',
        desc: '정서·인지·행동·관계를 종합적으로 살펴 현재의 어려움과 함께 변화 가능성과 개입의 방향을 도출합니다.',
        imgSrc: solution_icon_1,
    },
    {
        id: '02',
        title: '심리치료',
        desc: '내담자의 속도와 자율성을 존중하며, 감정과 행동의 패턴을 이해하고 새로운 대응을 시도하도록 돕습니다.',
        imgSrc: solution_icon_2,
    },
    {
        id: '03',
        title: '심리 교육 및 자문',
        desc: '보호자·교사·실무자가 정서와 행동을 이해하고 현장에서 적용 가능한 소통과 대응 방식을 갖추도록 지원합니다.',
        imgSrc: solution_icon_3,
    },
    {
        id: '04',
        title: '수퍼비전',
        desc: '정답을 제시하기보다 개입의 방향을 함께 점검하며, 안전하고 효과적인 실천이 지속되도록 돕습니다.',
        imgSrc: solution_icon_4,
    },
];

// 맞춤 전략 데이터
const strategyData = [
    {
        icon: solution_icon_5,
        title: '과정 중심의 심리 모델',
        desc: '진단명보다 정서·인지·행동·관계의\n상호작용에 주목합니다.',
    },
    {
        icon: solution_icon_6,
        title: '임상 현장에서 검증된 전문성',
        desc: '실제 상담 및 평가 경험을 바탕으로\n현장 중심의 솔루션을 지향합니다.',
    },
    {
        icon: solution_icon_7,
        title: "기술을 '이해의 도구'로 사용",
        desc: '기술을 판단이 아닌 더 나은\n이해를 위한 도구로 사용합니다.',
    },
    {
        icon: solution_icon_8,
        title: '개인-전문가-환경의 구조설계',
        desc: '개인 기록에서 상담, 교육, 자문까지\n실제 도움으로 이어지게 합니다.',
    },
    {
        icon: solution_icon_9,
        title: '자율성과 안전을 최우선으로',
        desc: '자율적이고 안전한 지원을 위해\n최적의 솔루션을 설계합니다.',
    },
    {
        icon: solution_icon_10,
        title: '확장 가능한 정신건강 인프라',
        desc: '개인에서 기관과 현장까지\n확장 가능한 기반을 만들어 갑니다.',
    },
];

export default function SolutionsPage() {
    return (
        <Box sx={{ width: '100%', bgcolor: '#ffffff' }}>
            {/* 1. 히어로 섹션 */}
            <Box
                component="header"
                sx={{
                    height: { xs: '70vh', md: '550px' },
                    minHeight: '400px',
                    width: '100%',
                    backgroundImage: `url(${service_bg})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    position: 'relative',
                }}
            >
                <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
                    <Box
                        sx={{
                            textAlign: 'left',
                            color: '#1a1a1a', // standard text
                            pl: 3,
                        }}
                    >
                        <Typography
                            sx={{
                                fontWeight: 900,
                                mb: 2,
                                letterSpacing: '0.1em',
                                color: '#1a1a1a',
                                fontSize: { xs: '1rem', md: '1.25rem' },
                            }}
                        >
                            SOLUTION
                        </Typography>
                        <Typography
                            variant="h3"
                            component="h2"
                            sx={{
                                fontWeight: 300,
                                mb: 1,
                                fontSize: { xs: '2rem', md: '3.2rem' },
                                wordBreak: 'keep-all',
                                color: '#1a1a1a',
                            }}
                        >
                            현장에서 실제로 작동하는
                        </Typography>
                        <Typography
                            variant="h3"
                            sx={{
                                fontWeight: 300,
                                mb: 1,
                                fontSize: { xs: '2rem', md: '3.2rem' },
                                wordBreak: 'keep-all',
                                color: '#1a1a1a',
                            }}
                        >
                            심리지원 서비스를
                        </Typography>
                        <Typography
                            variant="h3"
                            sx={{
                                fontWeight: 800,
                                fontSize: { xs: '2rem', md: '3.2rem' },
                                wordBreak: 'keep-all',
                                color: '#1a1a1a',
                            }}
                        >
                            직접 설계·운영합니다.
                        </Typography>
                    </Box>
                </Container>
            </Box>

            {/* 2. 기관 맞춤형 심리지원 프로그램 Section */}
            <Box sx={{ py: { xs: 8, md: 15 }, bgcolor: '#ffffff' }}>
                <Container maxWidth="lg">
                    {/* 타이틀 */}
                    <Box mb={8}>
                        <Typography
                            sx={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.14em', color: '#005a8d', mb: '12px' }}
                        >
                            SERVICE PROGRAMS
                        </Typography>
                        <Typography
                            variant="h4"
                            sx={{ fontWeight: 800, mb: 2, letterSpacing: '-0.02em' }}
                        >
                            체감형 현장 개입
                            <br />
                            심리지원 프로그램
                        </Typography>
                        <Typography
                            sx={{
                                color: '#555555',
                                fontSize: '1.1rem',
                                wordBreak: 'keep-all',
                                lineHeight: 1.6,
                            }}
                        >
                            지역사회 정신건강 사각지대 해소를 위해 전문 인력이 직접 방문, 현장
                            중심의 심리서비스를 지원합니다.
                        </Typography>
                    </Box>

                    {/* Bento Box Layout */}
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: { xs: '1fr', md: '1fr 2fr' },
                            gap: 3,
                            mb: 3,
                        }}
                    >
                        {/* Box 1 (Top Left) */}
                        <Box
                            sx={{
                                bgcolor: '#f4f7f2', // light green-ish
                                borderRadius: 6,
                                p: { xs: 4, md: 5 },
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <Box
                                component="img"
                                src={service_icon_1}
                                alt="child icon"
                                sx={{ width: 40, height: 35, mb: 3, objectFit: 'contain' }}
                            />
                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 700,
                                    mb: 2,
                                    wordBreak: 'keep-all',
                                    letterSpacing: '-0.02em',
                                    lineHeight: 1.4,
                                }}
                            >
                                아동·청소년 대상
                                <br />
                                정서·행동 개입 프로그램
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{ color: '#555', wordBreak: 'keep-all', lineHeight: 1.6 }}
                            >
                                아이의 정서와 행동 발달을 함께 살피는
                                <br />
                                전문적인 개입 프로그램
                            </Typography>
                        </Box>

                        {/* Box 2 (Top Right) */}
                        <Box
                            sx={{
                                bgcolor: '#f1f6f8', // light blue-ish
                                borderRadius: 6,
                                p: { xs: 4, md: 0 },
                                pl: { md: 5 },
                                display: 'flex',
                                flexDirection: { xs: 'column', md: 'row' },
                                alignItems: 'center',
                                gap: { xs: 4, md: 6 },
                                height: { xs: 'auto', md: '100%' },
                                minHeight: { xs: 'auto', md: '100%' },
                                overflow: 'hidden',
                            }}
                        >
                            <Box
                                component="img"
                                src={img_service_1}
                                alt="Slow Learner"
                                sx={{
                                    width: { xs: '100%', md: 'auto' },
                                    height: { md: '100%' },
                                    maxHeight: { xs: 200, md: 'none' },
                                    objectFit: 'contain',
                                    objectPosition: 'left bottom',
                                    alignSelf: { md: 'flex-end' }, // aligns to bottom
                                }}
                            />
                            <Box sx={{ py: { md: 5 }, pr: { md: 5 } }}>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: 700,
                                        wordBreak: 'keep-all',
                                        letterSpacing: '-0.02em',
                                        lineHeight: 1.4,
                                    }}
                                >
                                    거점 기반 전문 심리 서비스 & 바우처
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: '#555',
                                        wordBreak: 'keep-all',
                                        lineHeight: 1.6,
                                        mb: 2,
                                    }}
                                >
                                    가람마인드 심리상담센터(대구 수성구 소재) 기반의 고품질 대면
                                    서비스
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{ color: '#555', wordBreak: 'keep-all', lineHeight: 1.6 }}
                                >
                                    • 중심 거점 운영
                                    <br />
                                    • 공공 바우처 연계
                                    <br />
                                    • 위기군 특성화 평가
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column-reverse', md: 'row' },
                            alignItems: 'stretch',
                            gap: 3,
                            mt: { xs: 4, md: 0 },
                        }}
                    >
                        {/* Box 3 (Bottom Left) */}
                        <Box
                            sx={{
                                flex: 3,
                                bgcolor: '#f4f8fa', // very light cyan/blue
                                borderRadius: 6,
                                p: { xs: 4, md: 0 },
                                pl: { md: 5 },
                                display: 'flex',
                                flexDirection: { xs: 'column', md: 'row' },
                                alignItems: 'center',
                                gap: { xs: 4, md: 6 },
                                overflow: 'hidden',
                                height: 'auto',
                            }}
                        >
                            <Box
                                component="img"
                                src={img_service_2}
                                alt="Teacher Training"
                                sx={{
                                    width: { xs: '88%', md: 'auto' },
                                    height: { md: '88%' },
                                    maxHeight: { xs: 200, md: 'none' },
                                    objectFit: 'contain',
                                    objectPosition: 'left bottom',
                                    alignSelf: { md: 'flex-end' }, // aligns to bottom
                                    mb: 1.5,
                                }}
                            />
                            <Box sx={{ py: { md: 5 }, pr: { md: 5 } }}>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: 700,
                                        wordBreak: 'keep-all',
                                        letterSpacing: '-0.02em',
                                        lineHeight: 1.4,
                                    }}
                                >
                                    전문가 양성 연수 및 교육
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: '#555',
                                        wordBreak: 'keep-all',
                                        lineHeight: 1.6,
                                        mb: 2,
                                    }}
                                >
                                    임상/상담심리 수련생 및 신입 상담사를 위한 현장 중심 인재 양성
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{ color: '#555', wordBreak: 'keep-all', lineHeight: 1.6 }}
                                >
                                    • 심리평가 실무 훈련
                                    <br />
                                    • 근거 기반 상담 기범
                                    <br />
                                    • 디지털 헬스케어 융합 교육
                                </Typography>
                            </Box>
                        </Box>

                        {/* Box 4 (Bottom Right) */}
                        <Box
                            sx={{
                                flex: 1,
                                bgcolor: '#f4f7f2', // light green-ish
                                borderRadius: 6,
                                p: { xs: 4, md: 5 },
                                display: 'flex',
                                flexDirection: 'column',
                                height: 'auto',
                            }}
                        >
                            <Box
                                component="img"
                                src={service_icon_2}
                                alt="AI Solution"
                                sx={{ width: 40, height: 40, mb: 3, objectFit: 'contain' }}
                            />
                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 700,
                                    mb: 2,
                                    wordBreak: 'keep-all',
                                    letterSpacing: '-0.02em',
                                    lineHeight: 1.4,
                                }}
                            >
                                현장 실무자 대상
                                <br />
                                사례 자문
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{ color: '#555', wordBreak: 'keep-all', lineHeight: 1.6 }}
                            >
                                복지관, 학교, 지자체 기관의
                                <br />
                                든든한 개입 역량 지원군
                            </Typography>
                        </Box>
                    </Box>
                </Container>
            </Box>

            {/* 3. 솔루션 4단계 섹션 */}
            <Container sx={{ py: { xs: 6, md: 10 } }}>
                <Typography
                    sx={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.14em', color: '#005a8d', mb: '12px' }}
                >
                    SOLUTION PROCESS
                </Typography>
                <Typography
                    variant="h4"
                    sx={{ fontWeight: 800, mb: 2, letterSpacing: '-0.02em' }}
                >
                    4단계 심리 솔루션 접근법
                </Typography>
                <Typography
                    sx={{
                        color: '#555555',
                        fontSize: '1.1rem',
                        wordBreak: 'keep-all',
                        lineHeight: 1.6,
                        mb: '64px'
                    }}
                >
                    현장 서비스를 효과적으로 뒷받침하는 체계적인 심리 솔루션 프로세스입니다.
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                    {solutionsData.map((item, index) => (
                        <Box
                            key={item.id}
                            sx={{
                                display: 'flex',
                                // 홀수/짝수 인덱스에 따라 좌우 배치 반전 (모바일은 항상 세로)
                                flexDirection: {
                                    xs: 'column',
                                    md: index % 2 === 0 ? 'row' : 'row-reverse',
                                },
                                alignItems: 'center',
                                bgcolor: '#F5F8FA',
                                borderRadius: 8,
                                p: { xs: 3, md: 5 },
                                gap: { xs: 2, md: 6 },
                                height: { xs: 'auto', md: '230px' },
                            }}
                        >
                            {/* 이미지 영역 */}
                            <Box
                                sx={{
                                    flex: 0.4,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    width: '100%',
                                }}
                            >
                                <Box
                                    component="img"
                                    src={item.imgSrc}
                                    alt={item.title}
                                    sx={{ maxWidth: '200px', width: '100%', height: 'auto' }}
                                />
                            </Box>

                            {/* 텍스트 영역 */}
                            <Box sx={{ flex: 1.5 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <Typography
                                        variant="h4"
                                        fontWeight="900"
                                        color="#045584"
                                        sx={{ mr: 1.5 }}
                                    >
                                        {item.id}
                                    </Typography>
                                    <Typography variant="h4" fontWeight="bold">
                                        {item.title}
                                    </Typography>
                                </Box>
                                <Typography
                                    color="#000000"
                                    sx={{
                                        lineHeight: 1.6,
                                        wordBreak: 'keep-all',
                                        fontSize: {xs: '1rem', md: '1.2rem'},
                                    }}
                                >
                                    {item.desc}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Container>

            {/* 4. 맞춤 전략 섹션 */}
            <Box sx={{ bgcolor: '#F0F5F7', py: { xs: 8, md: 12 }, mt: 4, pl: 4, pr: 4 }}>
                <Container maxWidth="lg">
                    <Typography variant="h4" align="left" sx={{ mb: 8 }}>
                        AI 기반 전문 심리 솔루션을 위한{' '}
                        <Box component="span" fontWeight="bold">
                            맞춤 전략
                        </Box>
                    </Typography>

                    {/* 핵심 변경 포인트: Grid 컴포넌트 대신 CSS Grid 사용 */}
                    <Box
                        sx={{
                            display: 'grid',
                            // 모바일은 1열, 태블릿(md) 이상부터는 정확히 동일한 너비의 3열로 고정
                            gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
                            // 가로 여백(columnGap)과 세로 여백(rowGap)을 따로 설정 가능
                            columnGap: { xs: 4, md: 6 },
                            rowGap: { xs: 6, md: 8 },
                        }}
                    >
                        {strategyData.map((item, index) => (
                            <Box
                                key={index}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <Box
                                    component="img"
                                    src={item.icon}
                                    alt={item.title}
                                    sx={{
                                        width: '48px',
                                        height: '48px',
                                        mb: 2,
                                        objectFit: 'contain',
                                    }}
                                />
                                <Typography
                                    fontWeight="700"
                                    fontSize="1.2rem"
                                    sx={{ mt: 0.5, mb: 1, wordBreak: 'keep-all' }}
                                >
                                    {item.title}
                                </Typography>
                                <Typography
                                    sx={{
                                        lineHeight: 1.6,
                                        wordBreak: 'keep-all',
                                        whiteSpace: 'pre-line',
                                    }}
                                >
                                    {item.desc}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Container>
            </Box>

            {/* 5. Final Quote Section */}
            <Box
                sx={{
                    position: 'relative',
                    py: { xs: 8, md: 12 },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                }}
            >
                {/* Center Typography */}
                <Box sx={{ textAlign: 'center', zIndex: 1, px: { xs: 4, md: 2 } }}>
                    <Typography
                        sx={{
                            fontSize: { xs: '3rem', md: '4rem' },
                            color: '#005a8d',
                            lineHeight: 0.5,
                            mb: 2,
                            mt: 2,
                        }}
                    >
                        “
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: { xs: '1.2rem', md: '1.4rem' },
                            fontWeight: 600,
                            color: '#1a1a1a',
                            mb: 1.5,
                            wordBreak: 'keep-all',
                        }}
                    >
                        단 한번으로 끝나는 상담이 아니라
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: { xs: '1.3rem', md: '1.7rem' },
                            fontWeight: 800,
                            color: '#1a1a1a',
                            wordBreak: 'keep-all',
                        }}
                    >
                        ‘지속 가능한 관계 중심 개입’을 목표로 합니다.
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: { xs: '3rem', md: '4rem' },
                            color: '#005a8d',
                            lineHeight: 0.5,
                            mt: 4,
                            display: 'inline-block',
                            transform: 'rotate(180deg)',
                        }}
                    >
                        “
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}
